/**
 * Component Registry for Case Associates Lp Theme
 * 
 * Extends the base landing-page theme registry with Case Associates Lp specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';

import { AmenitiesList } from './components/AmenitiesList';
import { CTASection } from './components/CTASection';
import { Fees } from './components/Fees';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PropertyOverview } from './components/PropertyOverview';
import { SectionNav } from './components/SectionNav';
import { ThankYouHero } from './components/ThankYouHero';

const caseassociateslpOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  CTASection,
  Fees,
  Footer,
  Header,
  Hero,
  Navigation: SectionNav,
  PropertyOverview,
  ThankYouHero,
};

/**
 * Final merged registry for Case Associates Lp properties.
 * Inherits all components from the landing-page theme, with Case Associates Lp overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...caseassociateslpOverrides,
};

export default registry;
